import { render, staticRenderFns } from "./accountPage.vue?vue&type=template&id=59a13b14&scoped=true"
import script from "./accountPage.vue?vue&type=script&lang=ts"
export * from "./accountPage.vue?vue&type=script&lang=ts"
import style0 from "./accountPage.vue?vue&type=style&index=0&id=59a13b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a13b14",
  null
  
)

export default component.exports